import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const usePatientWalletDetail = (
  patientId,
  params = {},
  options = {},
) => {
  return useQuery(
    ["patientWalletDetail", patientId, params],
    async () => {
      if (!patientId) {
        throw new Error("Patient ID is required");
      }

      const res = await http.get(HTTP_ENDPOINTS.getPatientWalletDetail(), {
        params: {
          patient_id: patientId,
          ...params,
        },
      });

      // Handle cases where PHP warnings/errors are prepended to JSON response
      let responseData = res.data;
      if (typeof responseData === "string") {
        // Extract JSON from response that might have PHP warnings prepended
        const jsonMatch = responseData.match(/\{.*\}$/s);
        if (jsonMatch) {
          try {
            responseData = JSON.parse(jsonMatch[0]);
          } catch (e) {
            throw new Error("Invalid JSON response from server");
          }
        }
      }

      if (responseData.status !== 200) {
        throw new Error(
          responseData.data?.error ||
            responseData.message ||
            "Failed to fetch patient wallet detail",
        );
      }

      // Check for service errors even when status is 200
      if (responseData.data?.error) {
        throw new Error(responseData.data.error);
      }

      const composeResponse = {
        patientInfo: responseData.data.patient_info || {},
        breakdown: responseData.data.breakdown || {},
        reportData: responseData.data.report_data?.[0] || {}, // Raw data for calculations
        reportHeader: responseData.data.report_header || {},
        clinics: responseData.data.clinics || [],
        globalSettings: responseData.global_settings || {},
        exportFile: responseData.data.file || null, // For export responses
      };
      return composeResponse;
    },
    {
      enabled: !!patientId, // Only run query if patientId is provided
      ...options,
    },
  );
};
